import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import useAuthStore from './../store/useAuthStore';
import Sidebar from '../components/Sidebar';
import InterfaceContentSwitcher from '../components/InterfaceContentSwitcher'

const AdminPage = () => {
    const userRole = useAuthStore(state => state.userRole)

    if (userRole !== 'admin') return <Navigate to="/" />;

    return (
        <div className='app-container'>
            <Sidebar />
            <InterfaceContentSwitcher />
        </div>
    );
}

export default AdminPage;
